import * as translationHelper from "../helpers/translationHelper";

const initialState = {
    languages: translationHelper.getRedlikeLanguages()
};

/**
 * Structure of lang store:
 * - languages {Array}
 */
export const langReducer = (state = initialState) => {
    return state;
};
